module.exports = __webpack_public_path__ + "media/akshay-landscape.1df5f7a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/akshay-landscape.mp4
// module id = 821
// module chunks = 1